import classNames from 'classnames'
import React from 'react'
import Breadcrumbs from '../seo/Breadcrumbs'

import FooterAppAutoPromo from '../autopromo/FooterAppAutoPromoPE'
import s from './Footer.less'
import FooterCocorico from './FooterCocorico'
import FooterInfos from './footerInfos/FooterInfos'
import FooterPrivacy from './footerInfos/FooterPrivacy'
import FooterTopSearch from './FooterTopSearch'

const Footer = ({ privacy = true, displayAppAutoPromo = true }) => (
  <div className={classNames(s.footer)}>
    {displayAppAutoPromo && <FooterAppAutoPromo />}
    <div className={classNames(s.borderBottom, s.detailsSpacing)}>
      <Breadcrumbs />
      {privacy && <FooterPrivacy />}
      <FooterTopSearch />
      <FooterInfos />
    </div>
    <FooterCocorico />
  </div>
)

export default Footer
